/**
 * Custom validator for valid checkbox
 * @param  {String} value | input checked
 * @param {Object} options
 * @returns {String|null} returns null which validates as true in validate.js or an error string
 */
const checked = function (value, options) {
  const message = options && options.message ? options.message : this.options.message
  if (value !== true) {
    return message
  }
  return null
}

export default checked
